import { contact } from '../../portfolio'
import './Contact.css'

const Contact = () => {
  if (!contact.email) return null

  return (
    <section className='section contact center padding-top  ' id='contact'>
      <h2 className='section__title padding-b'>Get In Touch.</h2>
      <p style={{textAlign: "center"}}>Got a opportunity or just want to say hello? Go ahead.</p>
      <a className='p-t' href={`mailto:${contact.email}`}>
        <span type='button' className='btn btn--outline'>
          Say Hello!
        </span>
      </a>
    </section>
  )
}

export default Contact
